import { apiClientVersioned, returnData } from '../index'

import type { IGptPublicLink } from '../types/publicGpt'

/**
 * Admin API for a GPT's public share link. All endpoints require a platform-admin
 * session. `apiClientVersioned` already prefixes `/api/v1`, so paths are relative.
 *
 * Backend: `evergpt-api` `admin_public_links_router` (mounted under `/api/v1/gpts`).
 */
export const GptPublicLinkApi = {
  /** Current link status. Responds 404 when no link exists yet (an expected state). */
  get: (gptId: string) =>
    returnData(
      apiClientVersioned.get<IGptPublicLink>(`/gpts/${gptId}/public-link`),
    ),
  /** Create the link. Idempotent server-side — returns the existing link if present. */
  create: (gptId: string) =>
    returnData(
      apiClientVersioned.post<IGptPublicLink>(`/gpts/${gptId}/public-link`),
    ),
  /** Rotate the share token; old URLs stop working. */
  regenerate: (gptId: string) =>
    returnData(
      apiClientVersioned.post<IGptPublicLink>(
        `/gpts/${gptId}/public-link/regenerate`,
      ),
    ),
  /** Enable/disable the link without changing the token. */
  setActive: (gptId: string, isActive: boolean) =>
    returnData(
      apiClientVersioned.patch<IGptPublicLink>(`/gpts/${gptId}/public-link`, {
        is_active: isActive,
      }),
    ),
  /** Soft-delete (deactivate) the link. */
  deactivate: (gptId: string) =>
    returnData(
      apiClientVersioned.delete<IGptPublicLink>(`/gpts/${gptId}/public-link`),
    ),
}
